export default __webpack_public_path__ + "static/media/terapia.d24d7f6e.jpg";